import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { Focusable } from '../navigation/index';
import scaleSize from '../../utils/scale-size';
import getLocalized from '../../utils/get-localized';
import menuIcons from './menu-icons';

const StyledMenuItem = styled(Focusable)`
  width: ${scaleSize(540)}px;
  height: ${scaleSize(80)}px;
  font-size: ${scaleSize(36)}px;
  line-height: ${scaleSize(80)}px;
  padding-left: ${scaleSize(122)}px;
  color: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.mainTextColor)};
  font-family: 'RobotoRegular', sans-serif;
  white-space: nowrap;
  text-align: left;
  display: block;
  position: relative;
  box-sizing: border-box;

  .fill-change {
    fill: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.iconDefaultColor)};
  }
  .stroke-change {
    stroke: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.iconDefaultColor)};
  }

  svg {
    position: absolute;
    top: 50%;
    left: ${scaleSize(26)}px;
    transform: translate3d(
      ${({ isMenuFocused }) => (isMenuFocused ? 0 : scaleSize(440))}px,
      -50%,
      0
    );
  }

  &:before {
    content: '';
    width: ${scaleSize(16)}px;
    height: ${scaleSize(60)}px;
    border-radius: ${scaleSize(8)}px;
    background-color: ${({ theme }) => theme.activeColor};
    position: absolute;
    top: ${scaleSize(10)}px;
    left: ${scaleSize(-8)}px;
    transform: translate3d(${({ isMenuFocused }) => (isMenuFocused ? 0 : scaleSize(440))}px, 0, 0);
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  }

  &:focus {
    &:before {
      background-color: ${({ theme }) => theme.defaultColor};
    }
  }

  &:focus {
    background: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.defaultColor};
    .fill-change {
      fill: ${({ theme }) => theme.defaultColor};
    }
    .stroke-change {
      stroke: ${({ theme }) => theme.defaultColor};
    }
  }
`;

class MenuItem extends Component {
  static ACTION_ITEM_ID = 'active-menu-item';

  onFocus = () => {
    const { onFocus } = this.props;

    onFocus && onFocus();
  };

  onBlur = () => {
    const { onBlur } = this.props;

    onBlur && onBlur();
  };

  onEnter = () => {
    const { onEnter, item } = this.props;
    onEnter && onEnter(item);
  };

  render() {
    const { item, isActive, isMenuFocused } = this.props;

    const Icon = menuIcons[item.dashboardTag];

    return (
      <StyledMenuItem
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onEnter={this.onEnter}
        isMenuFocused={isMenuFocused}
        focusOnMouseEnter
        isActive={isActive}
        id={isActive ? MenuItem.ACTION_ITEM_ID : undefined}
      >
        {Icon && <Icon />}
        <span>{getLocalized(item.titles, item.title)}</span>
      </StyledMenuItem>
    );
  }
}

export default MenuItem;
